// extracted by mini-css-extract-plugin
export var container = "_8f-0";
export var error = "_8f-9";
export var label = "_8f-5";
export var light = "_8f-6";
export var md = "_8f-3";
export var sm = "_8f-2";
export var thin = "_8f-8";
export var thinBold = "_8f-7";
export var vertical = "_8f-4";
export var xs = "_8f-1";